const root = 'https://api.izuiyou.com/chatbot/v1/ai'
export default root
